export default __webpack_public_path__ + "static/media/screen4.4a80952d.png";